module.exports = __webpack_public_path__ + "img/briefcase-medical.185b2f7d.svg";